
export interface MonitorProps {
    locations?: any[]
    anchors?: any[]
    onMarkerClick?: (item: any) => void
}

export class MonitorLayer {
    map: google.maps.Map
    config: MonitorProps | undefined
    locationMarks: any[] = []
    anchorMarks: any[] = []
    infoWindow = new google.maps.InfoWindow()

    constructor(map: google.maps.Map, config: MonitorProps | undefined) {
        this.map = map
        this.configure(config)
    }
    
    async configure(config: MonitorProps | undefined) {
        console.log("MonitorLayer.configure")
        
        if (!config) {
            return
        }
        this.config = config

        const { AdvancedMarkerElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;
        
        // cleanup old markers
        for (const mark of this.anchorMarks) {
            mark.setMap(null)
        }
        this.anchorMarks = []

        for (const mark of this.locationMarks) {
            mark.setMap(null)
        }
        this.locationMarks = []

        if (config.locations) {
            for (const loc of config.locations) {
                const marker = new google.maps.marker.AdvancedMarkerElement({
                    map: this.map,
                    content: this.buildLocationMarkContent(loc.params),
                    position: loc.gps,
                    title: loc.id,
                    zIndex: 0
                });
                marker.addListener('click', () => {
                    this.onMarkerClick(marker, loc)
                });

                this.locationMarks.push(marker)
            }
        }

        if (config.anchors) {
            for (const anchor of config.anchors) {
                let marker = new google.maps.Marker({
                    map: this.map,
                    position: anchor.gps,
                    zIndex: 1,
                    icon: {
                        path: google.maps.SymbolPath.CIRCLE,
                        scale: 7,
                        fillColor: anchor.params.days_not_localized.color,
                        fillOpacity: 1.0,
                        strokeColor: anchor.params.avg_deviation.color,
                        strokeWeight: 3
                    }
                });
                marker.addListener('click', () => {
                    this.onMarkerClick(marker, anchor)
                });
                this.anchorMarks.push(marker)
            }
        }


        const bounds = this.getBounds()
        if (bounds) {
            this.map.fitBounds(bounds)
        }
    }

    onMarkerClick(marker: any, info: any) {
        this.infoWindow.setContent(this.createInfoContent(info));
        this.infoWindow.open(undefined, marker);
        if (this.config?.onMarkerClick) {
            this.config.onMarkerClick(info)
        }
    }

    createInfoContent(info: any) {
        // Create a container for the info content
        const container = document.createElement('div');
        container.classList.add('info-bar-content');

        const title = document.createElement('div');
        title.classList.add('info-bar-title');
        title.textContent = info.name; // Replace with your actual title
        container.appendChild(title);

        if (info.location_name) {
            const lastLocalized = document.createElement('div');
            lastLocalized.textContent = `Location: ${info.location_name}`
            container.appendChild(lastLocalized);
        }

        if (info.date_localized) {
            const lastLocalized = document.createElement('div');
            lastLocalized.textContent = `Last localized: ${info.date_localized.toLocaleDateString()}`
            container.appendChild(lastLocalized);
        }

        // Loop through each key in the item object to create horizontal bars
        Object.keys(info.params).forEach(key => {
            let value = info.params[key]
            // Create a row for the bar chart
            const row = document.createElement('div');
            row.classList.add('info-bar-row');

            // Create the label for the bar
            const label = document.createElement('span');
            label.classList.add('info-bar-label');
            label.textContent = value.title

            // Create the bar container
            const barContainer = document.createElement('div');
            barContainer.classList.add('info-bar-container');

            // Create the bar itself
            const bar = document.createElement('div');
            bar.classList.add('info-bar');
            bar.style.width = `${value.value * 100}%`; // Bar width based on value
            bar.style.backgroundColor = value.color; // Bar color
            barContainer.appendChild(bar);

            // Create the value text span
            const valueText = document.createElement('span');
            valueText.classList.add('info-bar-value');
            valueText.textContent = value.valueText; // Assuming valueText is a property with the text to display

            // Append the label, bar container, and value text to the row
            row.appendChild(label);
            row.appendChild(barContainer);
            row.appendChild(valueText);

            // Append the row to the container
            container.appendChild(row);
        });

        return container;
      }

    buildLocationMarkContent(item: any) {
        const maxBarHeight = 25; // px

        const container = document.createElement("div");
        container.classList.add("location-health-chart");

        Object.keys(item).forEach(key => {
            const barContainer = document.createElement("div");
            barContainer.classList.add("health-bar-container");
    
            const bar = document.createElement("div");
            bar.classList.add("health-bar");
            bar.style.height = `${Math.abs(item[key].value) * maxBarHeight}px`;
            bar.style.backgroundColor = item[key].color;

            if (item[key].value >= 0) {
                bar.style.transform = `translateY(${(1 - item[key].value)*maxBarHeight}px)`;
            } else {
                bar.style.transform = `translateY(${maxBarHeight}px) scaleY(-1)`;
            }
           
            barContainer.appendChild(bar);
            container.appendChild(barContainer);
        });
    
        return container;
    }

    getBounds() {
        if (this.locationMarks.length == 0) {
            return null
        }

        let bounds = new google.maps.LatLngBounds();
        for (const marker of this.locationMarks) {
            bounds.extend(marker.position);
        }

        for (const marker of this.anchorMarks) {
            bounds.extend(marker.getPosition());
        }

        return bounds
    }

    onMapClick(event: google.maps.MapMouseEvent) {
        this.infoWindow.close();
    };
}